import React from 'react';
import {SelectDropdown, SelectDropdownProps} from './SelectDropdown';
import {GridContainer, VerticalSpacer} from '../';
import {AnimateOnViewWrap} from '../../wraps';

export interface SelectDropdownWithContainerProps extends SelectDropdownProps {
    disableAnim?: boolean;
    headerAnim?: boolean;
    hidden?: boolean;
}
export const SelectDropdownWithContainer = (
    props: SelectDropdownWithContainerProps
): JSX.Element | null => {
    const {disableAnim, headerAnim, hidden} = props;
    if (hidden) return null;

    return (
        <GridContainer>
            <AnimateOnViewWrap
                delay={headerAnim ? 0.75 : 0}
                translateY={headerAnim ? -30 : 30}
                disable={disableAnim}>
                <SelectDropdown {...props} />
                <VerticalSpacer variant="custom" spacing={6} />
            </AnimateOnViewWrap>
        </GridContainer>
    );
};
